import { userService } from "../services";
import config from "../config/config";

export const GeofenceAction = {
  getGeofenceList,
  getGeofenceById,
  saveGeofence,
  updateGeofence,
  deleteGeofence,
  getGeofencesTrailData,
  // saveNotification,
  // geofenceDeviceListGet,
  // getAllNotifications,
  // updateMaterNotification,
  // geofenceNotificationTypeUpdate,
  // deactivateGeofence,
  /* ============================== */
};

const getGeofenceBaseUrl = () => {
  return `${JSON.parse(localStorage.getItem("config")).baseUrl.replace("backend/", "")}ais-notification/`;
};

function buildUrl(baseUrl, params) {
  const url = new URL(baseUrl);

  // Filter and append valid params
  Object.entries(params).forEach(([key, value]) => {
    if (value != null) {
      url.searchParams.append(key, value);
    }
  });

  return url.toString();
}

/* get geofence list */
// async function getGeofenceList(payload) {
//   // let url = `http://staging.watsoo.com:8085/watsoo_traccer/${config.apiName.geofenceList}`;
//   // let url = `http://192.168.30.41:8085/watsoo_traccer/${config.apiName.geofenceList}`;
//   let url = `${getGeofenceBaseUrl()}${config.apiName.geofenceList}`;

//   // 192.168.30.41
//   const res = await userService.post(url, payload);

//   if (res && res.status === 200) return res.data;
//   else return null;
// }

async function getGeofenceList(payload) {
  const apiEndpoint = buildUrl(
    `${config.baseUrl}${config.apiName.getGeofenceList}`,
    payload,
  );
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

/* get geofence by geofence id */
// async function getGeofenceById(id) {
//   // let url = `${JSON.parse(localStorage.getItem("config")).baseUrl}api/v2/site?companyId=${decryptAesObj(localStorage.getItem('data')).companyId}&id=${id}`;
//   // let url = `http://staging.watsoo.com:8085/watsoo_traccer/${config.apiName.getGeofenceById}`;
//   // let url = `http://staging.watsoo.com:8085/watsoo_traccer/${config.apiName.getGeofenceById}`;
//   let url = `${getGeofenceBaseUrl()}${config.apiName.getGeofenceById}`;

//   const res = await userService.post(url, { id: id });

//   if (res && res.status === 200) return res.data;
//   else return null;
// }

async function getGeofenceById(payload) {
  const apiEndpoint = buildUrl(
    `${config.baseUrl}${config.apiName.getGeofenceById}`,
    payload,
  );
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

/* add geofence */

// async function saveGeofence(payload) {
//   // let url = `${JSON.parse(localStorage.getItem("config")).baseUrl}api/v2/site?companyId=${decryptAesObj(localStorage.getItem('data')).companyId}&id=${id}`;
//   // let url = `http://staging.watsoo.com:8085/watsoo_traccer/${config.apiName.getGeofenceById}`;
//   // let url = `http://staging.watsoo.com:8085/watsoo_traccer/${config.apiName.addGeofence}`;
//   let url = `${getGeofenceBaseUrl()}${config.apiName.addGeofence}`;

//   const res = await userService.post(url, payload);

//   if (res && res.status === 200) return res.data;
//   else return null;
// }

async function saveGeofence(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.addGeofence}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
}

/* ======================================= */
/*======== update geofence ===================*/
// async function updateGeofence(payload) {
//   // let url = `${JSON.parse(localStorage.getItem("config")).baseUrl}api/v2/site?companyId=${decryptAesObj(localStorage.getItem('data')).companyId}&id=${id}`;
//   // let url = `http://staging.watsoo.com:8085/watsoo_traccer/${config.apiName.getGeofenceById}`;
//   // let url = `http://staging.watsoo.com:8085/watsoo_traccer/${config.apiName.updateGeofence}`;
//   let url = `${getGeofenceBaseUrl()}${config.apiName.updateGeofence}`;

//   const res = await userService.post(url, payload);

//   if (res && res.status === 200) return res.data;
//   else return null;
// }

async function updateGeofence(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.updateGeofence}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
}
/* ============================================ */

/* ===============DELETE GEOFENCE================== */

async function deleteGeofence(payload) {
  // let url = `${JSON.parse(localStorage.getItem("config")).baseUrl}api/v2/site?companyId=${decryptAesObj(localStorage.getItem('data')).companyId}&id=${id}`;
  // let url = `http://staging.watsoo.com:8085/watsoo_traccer/${config.apiName.getGeofenceById}`;
  // let url = `http://staging.watsoo.com:8085/watsoo_traccer/${config.apiName.updateGeofence}`;
  let url = `${getGeofenceBaseUrl()}${config.apiName.deleteGeofence}?geofenceId=${payload.geofenceId}&userId=${payload.userId}`;

  const res = await userService.get(url);

  if (res && res.status === 200) return res.data;
  else return null;
}

/* =============SAVE NOTIFICATION==================================== */

// async function saveNotification(payload) {
//   // let url = `http://staging.watsoo.com:8085/watsoo_traccer/${config.apiName.geofenceList}`;
//   // let url = `http://192.168.30.41:8085/watsoo_traccer/${config.apiName.geofenceList}`;
//   let url = `${getGeofenceBaseUrl()}${config.apiName.geofenceNotifTypeUpdate}`;

//   // 192.168.30.41
//   const res = await userService.post(url, payload);

//   if (res && res.status === 200) return res.data;
//   else return null;
// }

// async function geofenceDeviceListGet(userId) {
//   try {
//     const url = `${getGeofenceBaseUrl()}${config.apiName.geofenceDeviceList}?userId=${userId}`;

//     let response = await userService.get(url);
//     if (response && response.status === 200) {
//       return response.data;
//     }
//   } catch (error) {
//     console.log("error", error);
//     return error;
//   }
// }
// async function getAllNotifications(payload) {
//   try {
//     const url = `${getGeofenceBaseUrl()}${config.apiName.getAllNotification}`;
//     let response = await userService.post(url, payload);
//     if (response) {
//       return response;
//     }
//   } catch (error) {
//     console.log(error);
//   }
// }

// async function geofenceNotificationTypeUpdate(payload) {
//   try {
//     const url = `${getGeofenceBaseUrl()}${config.apiName.geofenceNotifTypeUpdate}`;
//     let response = await userService.post(url, payload);
//     if (response) {
//       return response;
//     }
//   } catch (error) {
//     console.log(error);
//   }
// }

// async function updateMaterNotification(payload) {
//   try {
//     const url = `${getGeofenceBaseUrl()}${config.apiName.updateMaterNotification}`;
//     let response = await userService.post(url, payload);
//     if (response) {
//       return response;
//     }
//   } catch (error) {
//     console.log(error);
//   }
// }

// async function deactivateGeofence(payload) {
//   try {
//     const url = `${getGeofenceBaseUrl()}${config.apiName.deactivateGeofence}`;
//     let response = await userService.post(url, payload);
//     if (response) {
//       return response;
//     }
//   } catch (error) {
//     console.log(error);
//   }
// }

async function getGeofencesTrailData(payload) {
  const apiEndpoint = buildUrl(
    `${config.baseUrl}${config.apiName.getGeofencesTrailData}`,
    payload,
  );
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}
